import { render } from "./ProductVideos.vue?vue&type=template&id=efa020d2&scoped=true"
import script from "./ProductVideos.vue?vue&type=script&lang=js"
export * from "./ProductVideos.vue?vue&type=script&lang=js"

import "./ProductVideos.vue?vue&type=style&index=0&id=efa020d2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\GameToGo\\Desktop\\ecommerce-movie7-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efa020d2"]])

export default __exports__